import { Injectable } from '@angular/core';
import { ServiceCenterAssetDetail } from './models/service-center-asset-detail';

const TTL_MS = 5 * 60 * 1000;

interface Entry {
  detail: ServiceCenterAssetDetail;
  cachedAt: number;
}

@Injectable({ providedIn: 'root' })
export class AssetDetailCacheService {
  private readonly entries = new Map<string, Entry>();

  // Keyed by vehicle AND the My View scope sent to the server, so a mid-session My
  // View change can't surface a stale server-scoped activeAlerts/activeAlertCount.
  private key(vehicleId: string, allowedTags?: string[]): string {
    return `${vehicleId}|${[...(allowedTags ?? [])].sort().join(',')}`;
  }

  get(vehicleId: string, allowedTags?: string[]): ServiceCenterAssetDetail | null {
    const k = this.key(vehicleId, allowedTags);
    const entry = this.entries.get(k);
    if (!entry) return null;
    if (Date.now() - entry.cachedAt > TTL_MS) {
      this.entries.delete(k);
      return null;
    }
    return entry.detail;
  }

  set(vehicleId: string, detail: ServiceCenterAssetDetail, allowedTags?: string[]): void {
    this.entries.set(this.key(vehicleId, allowedTags), { detail, cachedAt: Date.now() });
  }

  clear(): void {
    this.entries.clear();
  }
}
